import { throttle } from '@js/utils/throttle'
import { buildSizeObserver } from '@js/observers'

const useIsSticky = (el, top = 0) => {
	const id = el.getAttribute('use-is-sticky') ?? 'sticky-element';
	const checkIsSticky = () => {
		if (el.getBoundingClientRect().top === top) {
			el.dataset.isSticky = '';
		} else {
			el.removeAttribute('data-is-sticky');
		}
	}
	window.addEventListener('scroll', throttle(100, checkIsSticky));
	checkIsSticky();

	buildSizeObserver(el, 'stickyOffset', '--sticky-offset');
}

export { useIsSticky }
